module.exports = __webpack_public_path__ + "static/RST-PIO-CAN-2-a1c420890d18eecd72b8b73be4da3051.jpg";